import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import Newnavigation from '../../../components/new-navigation/new_navigation';
import AboutusBanner from '../../../components/Aboutus-banner/AboutusBanner';
import ContactNew from '../../../components/contact-form/ContactNew';
import Footer from '../../../components/footer/Footer';
import { RETAIL_ECOMMERCE, UNIX_BANNER} from '../../../assets/images';
import { unixmicrosoft_heading, UnixMicrosoftAccord, CoreServices, UnixTestimonials, UnixServices, UnixcardInfo } from '../../../utils/unix-microsoft';
import {  OptimizingSeo, Retail_Ecommerce} from '../../../utils/Seo';
import HeaderSeo from '../../../components/HeaderSeo/Headerseo';
import ComAccord from '../../../components/Accordian/ComAccord';
import RetailProgress from '../../../components/RetailProgress/RetailProgress';
import CoreServicesList from '../../../components/core-serices/core-services';
import Testimonials from '../../../components/Testimonials/Testimonials';


const UNIXMicrosoftPlatform = () => {
  const sectionRef = useRef()
  const refcustom = sectionRef.current
    useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }, []);
    return (
        <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
    >
        <div className='service-page' ref={sectionRef}>
            <Newnavigation routeName="services"/>
            <HeaderSeo data={OptimizingSeo}/>
            <AboutusBanner bg={UNIX_BANNER} data={unixmicrosoft_heading}/>
            <CoreServicesList title="Our Core Data Warehousing Services" data={UnixServices} />
            <RetailProgress steps={UnixcardInfo} heading={"Why Choose Techno Genesis for UNIX & Microsoft Platforms Design?"}/>
            <Testimonials data={UnixTestimonials} />
            <div className="mb-50">
              <ComAccord data={UnixMicrosoftAccord} />
            </div>
            <ContactNew />
            <Footer />
        </div>
        </motion.div>
    )
}

export default UNIXMicrosoftPlatform